module.exports = "//cdn.mxpnl.com/static/asset-cache/bd0f68bf2502add78389183da4438e8e/iron/common/widgets/intro/images/onboarding-shapes-2.svg";